import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import ViewTrainingClass from "../view";
import ViewTrainingModuleResults from "./view";
import EditTrainingModuleResults from "./edit";
import { MODULE_TRAINING_CLASS } from "variables/constants";

const classModuleResultRoutes = [
	generateCRUDRoutes({
		mainTitle: "Module Results",
		basePath: "training-classes/:classeId/training-module-results",
		mainComponent: <ViewTrainingClass />,
	    layout: "/console",	   
	    subTitle:"Module Result",
	    viewComponent: <ViewTrainingModuleResults />,
	    createComponent: <EditTrainingModuleResults />,
	    editComponent: <EditTrainingModuleResults />,
		level:3,
		moduleId: MODULE_TRAINING_CLASS,   
	})
]

export default classModuleResultRoutes;